document.addEventListener('DOMContentLoaded', function () {

  /* =========================
     POPUP OPEN / CLOSE
  ========================= */

  const openBtn = document.getElementById('open-enquiry-popup');
  const popup = document.getElementById('enquiry-popup');
  const closeBtn = document.getElementById('close-popup');

  if (openBtn && popup) {
    openBtn.addEventListener('click', function (e) {
      e.preventDefault();

      popup.style.display = 'block';

      const productName = this.getAttribute('data-product');
      const form = popup.querySelector('form');

      if (!form) return;

      const productField = form.querySelector('#ContactForm-products');

      if (productField) {
        productField.value = productName || '';
      }
    });
  }

  if (closeBtn && popup) {
    closeBtn.addEventListener('click', function () {
      popup.style.display = 'none';
    });
  }


  /* =========================
     MULTISELECT (CONTACT PAGE ONLY)
  ========================= */

  document.querySelectorAll('form[id^="ContactForm"]').forEach(form => {

    const isPopup = form.closest('#enquiry-popup');

    let multiSelect,
        placeholder,
        dropdown,
        checkboxes,
        validator,
        error,
        productField;


    if (!isPopup) {

      multiSelect = form.querySelector('.multi-select');

      if (multiSelect) {

        placeholder = form.querySelector('.multi-select__placeholder');
        dropdown = multiSelect.querySelector('.multi-select__dropdown');
        checkboxes = multiSelect.querySelectorAll('input[type="checkbox"]');
        validator = form.querySelector('#ContactForm-products-validator');
        error = form.querySelector('#products-error');
        productField = form.querySelector('#ContactForm-products');


        /* Open / close multiselect */

        if (placeholder) {
          placeholder.addEventListener('click', function (e) {
            e.stopPropagation();
            multiSelect.classList.toggle('active');
          });
        }


        if (dropdown) {
          dropdown.addEventListener('click', function (e) {
            e.stopPropagation();
          });
        }


        document.addEventListener('click', function () {
          multiSelect.classList.remove('active');
        });


        /* Update selected products */

        function updateState() {
          const checked = multiSelect.querySelectorAll(
            'input[type="checkbox"]:checked'
          );

          if (checked.length === 0) {
            placeholder.textContent = '— Please choose an option —';

            if (productField) {
              productField.value = '';
            }
          } else {
            const values = Array.from(checked).map(function (cb) {
              return cb.value;
            });

            placeholder.textContent =
              checked.length + ' options selected';

            if (productField) {
              productField.value = values.join(', ');
            }
          }

          // no validation / error display anymore
        }


        checkboxes.forEach(function (cb) {
          cb.addEventListener('change', updateState);
        });
      }
    }


        /* =========================
       SUBMIT HANDLER
    ========================= */

    form.addEventListener('submit', async function (e) {
      e.preventDefault();

      /* =========================
         NATIVE VALIDATION
      ========================= */

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      /* =========================
         MULTISELECT VALIDATION
      ========================= */


      /* =========================
         HELPER
      ========================= */

      const getValue = function (selector) {
        const el = form.querySelector(selector);
        return el ? el.value.trim() : '';
      };

      /* =========================
         FORM VALUES
      ========================= */

      const firstName    = getValue('[id*="first-name"]');
      const lastName     = getValue('[id*="last-name"]');
      const companyName  = getValue('[id*="Company-name"]');
      const email        = getValue('[id*="email"]');
      const phone        = getValue('#ContactForm-phone');
      const country      = getValue('#ContactForm-country');
      const state        = getValue('#ContactForm-state');

      /* =========================
         PREPARE API PAYLOAD
      ========================= */

      const data = {
        "UserName": "admin.intech",
        "Password": "intech#789@*",
        "First Name": firstName,
        "Last Name": lastName,
        "Company Name": companyName,
        "Email Address": email,
        "Phone number": phone,
        "Telephone number": "",
        "Company Website": getValue('[id*="company-website"]'),
        "Location/City": "",
        "How did you find us ?": getValue('[id*="find-us"]'),
        "Product": getValue('#ContactForm-products'),
        "Enquiry description/Requirement/Comment": getValue('[id*="body"]'),
        "Market Segments": "",
        "Source Website": "Axisvalence",
        "Category": getValue('[id*="requirement-type"]'),
        "URL": window.location.href,
        "Country": country,
        "State": state
      };

      console.log("Axisvalence API Payload:", JSON.stringify(data, null, 2));

      /* =========================
         API CALL
      ========================= */

      let apiOk = false;

      try {
        const res = await fetch(
          "https://06c103768ed5ece2a67acd9eea57f5.d0.environment.api.powerplatform.com:443/powerautomate/automations/direct/cu/09/workflows/1253559e7cfb434dac92621548dde66d/triggers/manual/paths/invoke?api-version=1&sp=%2Ftriggers%2Fmanual%2Frun&sv=1.0&sig=NUVmvKFbLBUh6W4GvaNH58RciKFaveB7IaRfNZvDT4c",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json"
            },
            body: JSON.stringify(data)
          }
        );

        console.log("Axisvalence API Status:", res.status);
        const responseText = await res.text();
        console.log("Axisvalence API Response:", responseText);

        //apiOk = res.ok;
        apiOk = res.status === 200;
      } catch (err) {
        console.error("Axisvalence API Error:", err);
      }

      /* =========================
         HANDLE API RESULT
      ========================= */

      if (!apiOk) {
        // Show a generic error message (you can style this in Liquid)
        alert('There was a problem submitting your enquiry. Please try again in a few minutes.');
        return;
      }

      /* =========================
         SHOPIFY FORM SUBMISSION
      ========================= */

      // Prevent recursion: remove this listener, then submit natively
      form.removeEventListener('submit', arguments.callee);
      form.submit();
    });

  });

});